import { useState, useEffect, useRef } from 'react'
import { articulosApi } from '../api/notasVenta'

const money = n => '$ ' + (parseFloat(n) || 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

// lista (Martin, 31 ago 2026): si viene, el backend devuelve SOLO artículos con
// precio en esa lista — los demás no aparecen (supera la sug #23, que los
// mostraba en gris como "fuera de tu lista": sin sentido práctico).
export default function BuscadorArticulo({ onSelect, precios, clienteId = null, lista = null }) {
  const [query, setQuery] = useState('')
  const [resultados, setResultados] = useState([])
  const [abierto, setAbierto] = useState(false)
  const timer = useRef(null)
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => { if (!ref.current?.contains(e.target)) setAbierto(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const buscar = (texto) => {
    setQuery(texto)
    if (texto.length < 2) { setResultados([]); return }
    clearTimeout(timer.current)
    timer.current = setTimeout(async () => {
      try {
        const { data } = await articulosApi.buscar(texto, clienteId, lista)
        setResultados(data.data || data)
        setAbierto(true)
      } catch { }
    }, 250)
  }

  const seleccionar = (articulo) => {
    onSelect(articulo)
    setQuery('')
    setResultados([])
    setAbierto(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        style={styles.input}
        value={query}
        onChange={e => buscar(e.target.value)}
        placeholder="Buscar por descripción, código, rubro, tipo, marca, bodega, cepa, año..."
      />
      {abierto && resultados.length > 0 && (
        <div style={styles.dropdown}>
          {resultados.map(a => {
            const precio = precios ? precios[a.id] : undefined
            return (
              <div key={a.id} style={styles.item} onMouseDown={() => seleccionar(a)}>
                <div style={styles.fila}>
                  <strong>{a.codigo_alfa}</strong>
                  {a.codigo_cliente && <span style={styles.codigoCliente}>cliente: {a.codigo_cliente}</span>}
                  {precio != null
                    ? <span style={styles.precio}>{money(precio)}</span>
                    : (precios ? <span style={styles.sinPrecio}>elegir precio</span> : null)}
                </div>
                <span style={styles.desc}>{a.descripcion}</span>
                <span style={styles.meta}>
                  {[a.rubro, a.subrubro, a.tipo_prod, a.cepa, a.anio || null].filter(Boolean).join(' · ')}
                </span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

const styles = {
  input: { width: '100%', padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.9375rem', boxSizing: 'border-box' },
  dropdown: { position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, height: '240px', overflowY: 'auto' },
  item: { padding: '0.625rem 0.875rem', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '2px' },
  fila: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem' },
  precio: { fontSize: '0.85rem', fontWeight: 700, color: '#166534', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
  sinPrecio: { fontSize: '0.72rem', color: '#7c3aed', fontWeight: 600, whiteSpace: 'nowrap' },
  codigoCliente: { marginLeft: 'auto', fontSize: '0.7rem', color: '#1e40af', background: '#dbeafe', padding: '1px 6px', borderRadius: 4, whiteSpace: 'nowrap', fontWeight: 600 },
  desc: { fontSize: '0.75rem', color: '#64748b' },
  meta: { fontSize: '0.68rem', color: '#94a3b8', textTransform: 'capitalize' },
}
